import { render, staticRenderFns } from "./TextAreaConfigForm.vue?vue&type=template&id=d2553506&scoped=true&"
import script from "./TextAreaConfigForm.vue?vue&type=script&lang=js&"
export * from "./TextAreaConfigForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2553506",
  null
  
)

export default component.exports